import React from 'react';
import { useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import Modal from './ui/Modal';
import Button from './ui/Button';
import { addSlotSchema } from '../utils/validationSchemas';

/**
 * Componente: AddSlotModal
 * Modal auxiliar para Dono adicionar horário
 */
const AddSlotModal = ({ isOpen, onClose, onSubmit }) => {
  const now = new Date();
  const today = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-${String(now.getDate()).padStart(2, '0')}`;

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({
    resolver: zodResolver(addSlotSchema),
    defaultValues: {
      date: today,
      time: '09:00',
    },
  });

  const onSubmitForm = (data) => {
    onSubmit(data);
    reset();
    onClose();
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} title="Adicionar Horário Individual">
      <form onSubmit={handleSubmit(onSubmitForm)} className="space-y-4">
        <div>
          <label htmlFor="date" className="block text-sm font-medium text-gray-700">
            Data *
          </label>
          <input
            type="date"
            id="date"
            {...register('date')}
            min={today}
            className={`mt-1 block w-full border rounded-lg shadow-sm p-2 focus:ring-indigo-500 focus:border-indigo-500 ${
              errors.date ? 'border-red-500' : 'border-gray-300'
            }`}
          />
          {errors.date && (
            <p className="mt-1 text-sm text-red-600">{errors.date.message}</p>
          )}
        </div>
        <div>
          <label htmlFor="time" className="block text-sm font-medium text-gray-700">
            Hora *
          </label>
          <input
            type="time"
            id="time"
            {...register('time')}
            className={`mt-1 block w-full border rounded-lg shadow-sm p-2 focus:ring-indigo-500 focus:border-indigo-500 ${
              errors.time ? 'border-red-500' : 'border-gray-300'
            }`}
          />
          {errors.time && (
            <p className="mt-1 text-sm text-red-600">{errors.time.message}</p>
          )}
        </div>
        <div className="flex justify-end space-x-3 pt-4">
          <Button type="button" variant="secondary" onClick={onClose}>
            Cancelar
          </Button>
          <Button type="submit" variant="primary">
            Adicionar Horário
          </Button>
        </div>
      </form>
    </Modal>
  );
};

export default AddSlotModal;
